// extracted by mini-css-extract-plugin
module.exports = {"statistics":"statistics_statistics__8HuVv","title":"statistics_title__Xsnbr","list":"statistics_list__a7KEb","item":"statistics_item__pM7FH"};